export const initialSettingsState = {
    loading: false,
    error: null,
    dataSettings: null,
};
